export default "__VITE_PUBLIC_ASSET__e98c0df8__"